import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['group', 'listings'];

  connect() {
    this.updateLastCardListener();
  }

  updateLastCardListener() {
    const detailedScreeningCards = this.element.querySelectorAll('.detailed-screening__card');
    const lastEventCard = detailedScreeningCards[detailedScreeningCards.length - 1];
    if (lastEventCard) {
      lastEventCard.addEventListener(
        'detailedScreeningCardProcessed',
        this.handleLastscreeningCardProcessed
      );
    }
  }

  disconnect() {
    const detailedScreeningCards = this.element.querySelectorAll('.detailed-screening__card');
    const lastEventCard = detailedScreeningCards[detailedScreeningCards.length - 1];
    if (lastEventCard) {
      lastEventCard.removeEventListener(
        'detailedScreeningCardProcessed',
        this.handleLastscreeningCardProcessed
      );
    }
  }

  handleLastscreeningCardProcessed = () => {
    this.checkGroups();
    this.updateListingsVisibility();
  };

  checkGroups() {
    let anyGroupHasVisibleCards = false;
    this.groupTargets.forEach((group) => {
      const hasVisibleCards = group.querySelectorAll('.detailed-screening__card').length > 0;
      if (hasVisibleCards) {
        anyGroupHasVisibleCards = true;
      } else {
        group.remove();
      }
    });
    document.querySelector('.js-no-events').classList.toggle('-show', !anyGroupHasVisibleCards);
    this.dispatchCompletedEvent();
  }

  dispatchCompletedEvent() {
    const event = new CustomEvent('eventGroupProcessed', { bubbles: true });
    this.element.dispatchEvent(event);
  }

  updateListingsVisibility() {
    this.listingsTarget.classList.remove('hidden-content');
  }
}
